<form [formGroup]="searchForm" (ngSubmit)="onSearch()" [hidden]="hidden">
	<div class="div row align-items-end">
		<div class="form-group col-12 col-md-3">
			<label for="field">Champ</label>
			<select formControlName="field" class="form-control" (change)="onSelectFieldChange($event)">
				@for (field of fields; track field) {
					<option class="" [value]="field.name">{{ field.label }}</option>
				}
			</select>
			<!--<app-select
				[items]="listStringToObject(fields)"
				bindLabel="nom"
				bindValue="nom"
				[searchable]="true"
				placeholder="Champ"
				[clearable]="false"
				[loading]="this.fields == undefined"
				[formControl]="searchForm.get('field')"
			></app-select>-->
		</div>
		<div class="form-group col col-12 col-md-3">
			<label for="operator">Opérateur</label>
			<select formControlName="operator" class="form-control">
				@for (operator of getTypeFieldByName(selectedField?.type); track operator) {
					<option [value]="operator?.value">{{ operator?.label }}</option>
				}
			</select>
		</div>
		<div class="form-group col-12 col-md-3">
			@if (selectedField?.type == "bool") {
				<label for="value">Valeur</label>
				<select formControlName="value" class="form-control">
					<option class="" value="true">{{ "true" }}</option>
					<option class="" value="false">{{ "false" }}</option>
				</select>
			} @else if (selectedField?.type == "date") {
				<label class="form-label">choisir la date</label>
				<div class="input-group">
					<input
						type="date"
						class="form-control flatpickr flatpickr-input"
						mwlFlatpickr
						[altInput]="true"
						[altFormat]="'d-m-Y'"
						[dateFormat]="'d-m-Y'"
						[convertModelValue]="true"
						formControlName="value"
						placeholder="Choisir la date"
						readonly
						required
					/>
					<span class="input-group-text"><i class="ri-calendar-event-line"></i></span>
				</div>
			} @else if (selectedField?.type == "number") {
				<label for="value">Valeur</label>
				<input type="number" formControlName="value" class="form-control" placeholder="Search value" required />
			} @else {
				<label for="value">Valeur</label>
				<input formControlName="value" class="form-control" placeholder="Search value" required />
			}
		</div>
		<div class="col-12 col-md-2 pt-1"><button type="submit" [disabled]="this.searchForm.invalid" class="btn btn-primary">Search</button></div>
	</div>
	<div class="row">
		<div class="bage-filter">
			@for (filter of filterList; track filter?.name) {
				<span class="badge bg-info-subtle text-info m-2 fs-6">
					<i>{{ getFieldLabelByName(filter?.name) }} {{ filter?.label }} {{ filter?.value }}</i>
					<i (click)="removeFilter(filter)" style="font-size: 20px" class="bx bx-x"></i>
				</span>
			}
		</div>
	</div>
</form>
